<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.qualitative_reports', 2),
                        href: null,
                    },
                    {
                        name: group.name,
                        href: meta.links.group_show,
                    },
                    {
                        name: student.full_name,
                        href: null,
                    },
                    {
                        name: $tc('messages.comments', 2),
                        href: null,
                    },
                ]"
            >
                <template v-slot:corner>
                    <div>
                        <ActivityMenuOptions>
                            <InertiaLink
                                v-for="otherStudent in meta.links.students"
                                :href="otherStudent.url"
                                :key="otherStudent.url"
                                class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                role="menuitem"
                            >
                                {{ otherStudent.text }}
                            </InertiaLink>
                        </ActivityMenuOptions>
                    </div>
                </template>
            </SmartBreadcrumbs>
        </template>

        <div class="w-full flex space-x-4 justify-end">
            <AppButton :href="meta.links.create">
                {{ $t('messages.create') }}
            </AppButton>
        </div>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <span class="sr-only">{{ $t('messages.trimester') }}</span>
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.comment') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <span class="sr-only">{{ $t('messages.actions') }}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(comment, index) in comments"
                                :key="comment.id"
                            >
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    <div>{{ $t('messages.trimester') }} {{ comment.trimester }}</div>
                                    <div>
                                        {{ comment.date }}
                                    </div>
                                </td>
                                <td class="px-6 py-4 text-sm leading-5 text-gray-500 whitespace-pre-line">
                                    <p v-html="comment.comment" />
                                </td>
                                <td class="px-6 py-4 text-sm leading-5 text-gray-500 flex justify-end space-x-1">
                                    <InertiaSquareLinkButton action="edit" :href="comment.links.edit" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import ActivityMenuOptions from '@/components/pageSpecific/ActivityMenuOptions.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    components: {
        PanelPage,
        InertiaSquareLinkButton,
        ActivityMenuOptions,
        AppButton,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'comments', 'filters', 'student', 'group'],
    data() {
        return {
            form: this.$inertia.form({}),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
